// extracted by css-extract-rspack-plugin
export default {"banner":"DecoupledModeBanner-module__banner__n2WBo"};